import NextLink from "next/link";
import { ComponentProps } from "react";
import styles from "./index.module.css";

type LinkProps = ComponentProps<typeof NextLink>;

const Link = ({ children, target, ...linkProps }: LinkProps) => {
  return (
    <NextLink {...linkProps} className={styles.link} target={target ?? "_blank"} rel="noopener noreferrer">
      {children}
    </NextLink>
  );
};

export default Link;
